import {Request} from "../request.abstract";
import {Observable} from "rxjs/Observable";
import {BaseInterface} from "./api.models";
import {ProxyEndpoint} from "./proxy/api.service";

export class BaseEndpoint extends Request {
    collection(type?: string): Observable<BaseInterface[]> {
        return this.get('/v1/bases', this.createSearch({
            type: type
        }));
    }

    resource(id: number): Observable<BaseInterface> {
        return this.get('/v1/bases/' + id);
    }

    proxy(baseId: number): ProxyEndpoint {
        return new ProxyEndpoint(this.http, this.settings, baseId);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./src/app/shared/api/bases/api.service.ts